var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19_20754",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 21,
    height: 21
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19_20754)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M24.757 18.476C24.3801 19.7152 23.6887 20.8357 22.7502 21.7283C21.8116 22.6209 20.6578 23.2553 19.4013 23.5695C18.1447 23.8838 16.8282 23.8673 15.5799 23.5216C14.3316 23.1759 13.1941 22.5128 12.2783 21.5969C11.3624 20.681 10.6993 19.5436 10.3536 18.2953C10.0079 17.047 9.9914 15.7305 10.3057 14.4739C10.6199 13.2174 11.2543 12.0636 12.1469 11.125C13.0395 10.1865 14.16 9.49506 15.3992 9.11816C15.0063 10.4182 14.9734 11.8005 15.3041 13.1178C15.6348 14.435 16.3166 15.6379 17.277 16.5982C18.2373 17.5586 19.4402 18.2404 20.7574 18.5711C22.0747 18.9018 23.457 18.8689 24.757 18.476Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1984 18.0335C25.1183 17.9532 25.0177 17.8962 24.9076 17.8687C24.7975 17.8412 24.682 17.8441 24.5734 17.8773C23.3817 18.2376 22.1145 18.2678 20.907 17.9647C19.6994 17.6616 18.5967 17.0366 17.7164 16.1562C16.836 15.2759 16.211 14.1732 15.9079 12.9656C15.6048 11.7581 15.635 10.4909 15.9953 9.29916C16.0287 9.19057 16.032 9.07491 16.0046 8.96464C15.9772 8.85436 15.9203 8.75364 15.8399 8.67329C15.7596 8.59295 15.6589 8.53603 15.5486 8.50865C15.4383 8.48127 15.3227 8.48447 15.2141 8.51791C13.5664 9.02263 12.12 10.0342 11.0805 11.4085C10.1714 12.6155 9.61692 14.052 9.47927 15.5566C9.34162 17.0613 9.62628 18.5746 10.3013 19.9264C10.9762 21.2782 12.0148 22.4151 13.3003 23.2092C14.5857 24.0033 16.0672 24.4232 17.5781 24.4218C19.3409 24.4272 21.0567 23.8541 22.4625 22.7906C23.8369 21.7511 24.8484 20.3046 25.3531 18.657C25.3862 18.5488 25.3892 18.4337 25.362 18.3239C25.3348 18.2141 25.2782 18.1137 25.1984 18.0335ZM21.7109 21.7921C20.3871 22.7892 18.7477 23.2745 17.0945 23.1588C15.4413 23.043 13.8855 22.334 12.7135 21.1621C11.5416 19.9903 10.8324 18.4346 10.7165 16.7813C10.6006 15.1281 11.0858 13.4887 12.0828 12.1648C12.7323 11.307 13.5721 10.6117 14.5359 10.1335C14.481 10.5189 14.4534 10.9076 14.4531 11.2968C14.4554 13.451 15.3122 15.5163 16.8354 17.0395C18.3586 18.5628 20.4239 19.4195 22.5781 19.4218C22.9681 19.4217 23.3576 19.394 23.7437 19.339C23.2651 20.303 22.5693 21.1428 21.7109 21.7921Z",
    fill: "black"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19_20754)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.95312,
    y: 6.92188,
    width: 20,
    height: 20,
    fill: "#E2E8F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19_20754"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(6.95312 6.92188)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightDark);
export default __webpack_public_path__ + "static/media/light-dark.1e01b8256bcc51198be122211b605fbc.svg";
export { ForwardRef as ReactComponent };